import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    FormControl,
    Grid,
    TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import CustomChip from '../../components/mui/chip';

const Review = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [review, setReview] = useState();
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    useEffect(() => {
        const fetchReview = async () => {
            try {
                const response = await apiService.get(`/reviews/${params.id}`);
                const payload = response.data;
                setReview(payload.data);
            } catch (e) {
                console.error('Error fetching review:', e);
            }
        };

        fetchReview();
    }, [params.id]);

    useEffect(() => {
        const defaultValues = {
            username: review?.username,
            cat_id: review?.cat_id,
            sku: review?.sku,
            descript: review?.descript,
            reply: review?.reply,
            uptime: review?.uptime,
        }
        reset(defaultValues);
    }, [reset, review]);

    const goBack = () => {
        navigate(-1)
    }

    return (
        <Page title="Review">
            <Card>
                <CardContent sx={{ pt: 8 }}>
                    <Box sx={{ mb: 9, textAlign: 'center' }}>
                        <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                            리뷰
                        </Typography>
                    </Box>

                    <Grid container spacing={6}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='username'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            disabled
                                            value={value}
                                            label='User ID'
                                            id='username'
                                            onChange={onChange}
                                            placeholder='User ID을 입력해주세요'
                                            error={Boolean(errors.username)}
                                            aria-describedby='validation-async-username'
                                            variant="standard"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='cat_id'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            disabled
                                            value={value}
                                            label='CAT ID'
                                            id='cat_id'
                                            onChange={onChange}
                                            placeholder='CAT ID을 입력해주세요'
                                            error={Boolean(errors.cat_id)}
                                            aria-describedby='validation-async-cat_id'
                                            variant="standard"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='sku'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            disabled
                                            value={value}
                                            label='SKU'
                                            id='sku'
                                            onChange={onChange}
                                            placeholder='SKU을 입력해주세요'
                                            error={Boolean(errors.sku)}
                                            aria-describedby='validation-async-sku'
                                            variant="standard"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name='descript'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            disabled
                                            value={value}
                                            label='리뷰 내용'
                                            id='descript'
                                            onChange={onChange}
                                            placeholder='리뷰 내용을 입력해주세요'
                                            error={Boolean(errors.descript)}
                                            aria-describedby='validation-async-descript'
                                            variant="standard"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        
                        <Grid item xs={12}>
                            <CustomChip
                                skin='light'
                                color='info'
                                label={`등록날짜: ${review?.uptime}`}
                                sx={{ '& .MuiChip-label': { color: 'common.black' } }}
                            />
                        </Grid>
                    </Grid>
                </CardContent>

                {['imageUrl1', 'imageUrl2', 'imageUrl3'].map((key, idx) => {
                    const url = review?.[key];
                    if (!url) return null;

                    const isPdf = url.toLowerCase().endsWith('.pdf');
                    const fileName = url.split('/').pop();

                    return (
                        <Box key={key} sx={{ display: 'flex', justifyContent: 'left', margin: 4 }}>
                            {isPdf ? (
                                <a href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    src="/images/icons/file-icons/pdf.png"
                                    alt={fileName}
                                    style={{ width: 40, height: 40, marginRight: 8 }}
                                />
                                <span>{decodeURIComponent(fileName)}</span>
                                </a>
                            ) : (
                                <img
                                src={url}
                                alt={`첨부 이미지 ${idx + 1}`}
                                style={{ maxWidth: '100%', height: 'auto' }}
                                />
                            )}
                        </Box>
                    );
                })}

                <CardActions className='card-action'>
                    <Button variant='outlined' color='secondary' onClick={goBack}> Back </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default Review